export default __webpack_public_path__ + "static/media/x-box-image-detail-1.ec7a20ef.png";